module.exports = __webpack_public_path__ + "img/audio_close.f554d4a8.png";